import * as TonalKey from '@tonaljs/key';

/**
 * Gets information about a key signature
 * @param key - Key name (e.g. "C", "A")
 * @returns Key object from TonalJS
 */
export function getMajorKey(key: string) {
  return TonalKey.majorKey(key);
}

/**
 * Gets information about a minor key signature
 * @param key - Key name (e.g. "Cm", "Am")
 * @returns Minor key object from TonalJS
 */
export function getMinorKey(key: string) {
  return TonalKey.minorKey(key);
}
